var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"order-details"},[_c('div',{staticClass:"order-details__heading"},[_vm._v("\n    Products\n  ")]),_vm._v(" "),_c('base-table',{attrs:{"items":_vm.sopLines,"fields":_vm.fields}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }